var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShopOptionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.737,
    height: 79.737,
    viewBox: "0 0 79.737 79.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.33,40.8H23.39C6.977,40.8,0,33.789,0,17.409V2.492A2.51,2.51,0,0,1,2.492,0,2.51,2.51,0,0,1,4.984,2.492V17.409C4.984,31,9.8,35.815,23.39,35.815H41.3C54.886,35.815,59.7,31,59.7,17.409V2.492a2.492,2.492,0,0,1,4.984,0V17.409C64.72,33.789,57.71,40.8,41.33,40.8Z",
    transform: "translate(7.509 34.785)",
    fill: "#ef7a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.495,38.207A12.306,12.306,0,0,1,.069,24.453L2.295,2.259A2.519,2.519,0,0,1,4.787,0H20.3a2.492,2.492,0,0,1,2.492,2.259L25.02,24.453a12.425,12.425,0,0,1-3.09,9.7A12.731,12.731,0,0,1,12.495,38.207ZM7.013,4.984,5.019,24.951A7.427,7.427,0,0,0,6.847,30.8a7.981,7.981,0,0,0,11.3,0,7.506,7.506,0,0,0,1.827-5.847L17.977,4.984Z",
    transform: "translate(27.374 4.153)",
    fill: "#ef7a30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M15.793,38.207A13.831,13.831,0,0,1,2.337,26.048L.011,2.758A2.566,2.566,0,0,1,.642.831,2.442,2.442,0,0,1,2.5,0H12.636C22.4,0,26.956,4.087,28.318,14.12l.93,9.236A13.327,13.327,0,0,1,15.793,38.207ZM5.261,4.984,7.32,25.549a8.83,8.83,0,0,0,8.472,7.675A8.321,8.321,0,0,0,24.3,23.855l-.93-9.137c-1.03-7.509-3.455-9.735-10.731-9.735Z",
    transform: "translate(45.04 4.153)",
    fill: "#ef7a30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M13.531,38.207A13.327,13.327,0,0,1,.075,23.356l.9-9.137C2.368,4.087,6.919,0,16.687,0H26.82a2.548,2.548,0,0,1,1.861.831,2.439,2.439,0,0,1,.631,1.927l-2.326,23.29A13.831,13.831,0,0,1,13.531,38.207ZM16.687,4.984c-7.276,0-9.7,2.193-10.765,9.8l-.9,9.07a8.321,8.321,0,0,0,8.505,9.369A8.8,8.8,0,0,0,22,25.549l2.06-20.566Z",
    transform: "translate(5.207 4.153)",
    fill: "#ef7a30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M19.1,21.6H2.492A2.51,2.51,0,0,1,0,19.1V10.8C0,3.821,3.821,0,10.8,0S21.6,3.821,21.6,10.8V19.1A2.51,2.51,0,0,1,19.1,21.6ZM4.984,16.612H16.612V10.8c0-4.186-1.628-5.814-5.814-5.814S4.984,6.612,4.984,10.8Z",
    transform: "translate(29.071 53.989)",
    fill: "#ef7a30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H79.737V79.737H0Z",
    fill: "none",
    opacity: 0
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopOptionLogo);
export default __webpack_public_path__ + "static/media/ShopOptionLogo.033dc572f1973445c467b632940c5b5b.svg";
export { ForwardRef as ReactComponent };